import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ElasticExpedientesByKeyword, ExpedienteFiltroDTO, Expedientes, FullTextHojas, FullTextSummary, IResultadoDocument, IResultadoSearch, SearchOperators, Valores } from '../../../../core/model/inventories';
import { Page } from '../../../../core/model/page';
import { SelectValue, TemplateFieldsOrdered } from '../../../../core/model/template-field';
import { HighlightService } from '../../../../core/services/highlight.service';
import { HistoryService } from '../../../../core/services/history.service';
import { ImagenCacheBufferService } from '../../../../core/services/imagen-cache-buffer.service';
import { InventariosService } from '../../../../core/services/inventarios.service';
import { SeriesService } from '../../../../core/services/series.service';
import { ShoppingElementsService } from '../../../../core/services/shopping-elements.service';


@Component({
  selector: 'app-filtros-expediente',
  templateUrl: './filtros-expediente.component.html',
  styleUrls: ['./filtros-expediente.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        opacity: 1,
        transform: 'scaleY(1)'
      })),
      state('out', style({
        opacity: 0,
        transform: 'scaleY(0)'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ]),
    trigger('hiddenContainer', [
      state('in', style({
        height: '*'
      })),
      state('out', style({
        height: '0'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class FiltrosExpedienteComponent implements OnInit {

  @Input() page: Page;

  @Input() set rechargeRecords(rechargeRecords: boolean) {
    if (rechargeRecords) {
      this.reloadRecords();
    }
  }
  @Output() rechargeRecordsChange = new EventEmitter<boolean>();
  @Output() loading = new EventEmitter<boolean>();
  @Output() expedientesProcesados = new EventEmitter<IResultadoDocument<Expedientes>[]>();
  @Input() keyword: ElasticExpedientesByKeyword;
  @Output() keywordChange = new EventEmitter<ElasticExpedientesByKeyword>();
  @Output() advancedSearchFilter = new EventEmitter<ExpedienteFiltroDTO>();
  private numberFieldsShown = 6;
  advancedSearchState = 'out';
  isSearchByKeyword = false;
  filtro = new ExpedienteFiltroDTO();
  expedientes: IResultadoDocument<Expedientes>[];
  resultsShowed: IResultadoSearch<Expedientes>;
  hasFieldsRange = false;

  onlyPrestados: boolean = false;
  idGrupo: string; // 🥑🥑 SRR Agrego el idGrupo

  constructor(private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private inventoryService: InventariosService,
    private highlightService: HighlightService,
    private imagenCacheService: ImagenCacheBufferService,
    private shoppingElementsService: ShoppingElementsService,
    private seriesService: SeriesService,
    private historyService: HistoryService
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      const keywordsSearched = params.get('keyword');
      const operator = params.get('operator');
      this.onlyPrestados = params.get('onlyprestado') === 'true';
      this.idGrupo = params.get('idGrupo'); // 🥑🥑 SRR Agrego el idGrupo
      if (keywordsSearched && keywordsSearched != '') {
        this.isSearchByKeyword = true;
        this.filtro.VALORES = undefined;
        this.setKeywordForSearch(keywordsSearched.split(' ').filter(keywordSearch => keywordSearch && keywordSearch != ''), operator, this.onlyPrestados, this.idGrupo); // 🥑🥑 SRR Agrego el idGrupo
        return;
      }
      this.filtro = this.inventoryService.getFilter();
      if (this.filtro) {
        this.advancedSearchFilter.emit(this.filtro);
        this.searchRecordsByFilter();
      }
    });
    if (this.historyService.getPrevious() && this.historyService.getPrevious().url.indexOf('(contenido:expediente)') >= 0) {
      this.filtro = this.inventoryService.getFilter();
      if (this.filtro) {
        this.searchRecordsByFilter();
      } else {
        this.filtro = new ExpedienteFiltroDTO();
      }
    } else {
      this.inventoryService.removeFilter();
      this.filtro = new ExpedienteFiltroDTO();
    }
  }

  setKeywordForSearch(keyword: string | string[], operator: string, onlyprestado: boolean, idGrupo: string) {
    const keywords = (typeof keyword == 'string') ? keyword.split(' ').filter(keywordSearch => keywordSearch && keywordSearch != '')
      : keyword;
    const searchOperator = SearchOperators[operator];
    this.keyword = new ElasticExpedientesByKeyword(keywords, searchOperator ? searchOperator : SearchOperators.OR, onlyprestado, idGrupo); // 🥑🥑 SRR Agrego el idGrupo
    this.keywordChange.emit(this.keyword);
    this.clearAdvancedSearchFilter();
    this.reloadRecords();
  }
  private clearAdvancedSearchFilter() {
    this.advancedSearchFilter.emit(undefined);
    this.inventoryService.saveFilter(undefined);
  }

  redirectToRecordsWithSearch(search: ElasticExpedientesByKeyword) {
    this.inventoryService.notUnload = true;
    this.router.navigate(['docout', {
      outlets: {
          contenido: ['inventarios', search.PALABRAS_CLAVE.join(' '), {
          operator: search.OPERADOR,
          onlyprestado: search.onlyPrestadas,
          inventoryType: 'inventarios',
          idGrupo: search.idGrupo // 🥑🥑 SRR Agrego el idGrupo
        }]
      }
    }]);
  }

  toggleAdvancedSearch() {
    this.advancedSearchState = this.advancedSearchState == 'in' ? 'out' : 'in';
  }

  advancedSearch(event) {
    const objectValue = {};
    event.campos.forEach(campo => objectValue[campo.nombre] = this.getValueField(campo));
    this.filtro.VALORES = objectValue;
    this.keyword = undefined;
    this.keywordChange.emit(undefined);

    this.isSearchByKeyword = false;
    this.inventoryService.saveFilter(this.filtro);
    this.advancedSearchFilter.emit(this.filtro);
    if (this.isInventoryUrlWithoutText()) {
      this.advancedSearchState = 'out';
      this.searchRecordsByFilter();
      return;
    }
    this.router.navigate(['docout', {
      outlets: {
        contenido: ['inventarios', {
          inventoryType: 'inventarios'
        }] } }]);
  }
  getValueField(campo: any): any {
    if (campo.multivalue) {
      return this.getMultivaluesAdvancedSearch(campo.valor);
    }

    if (campo.valor && !(campo.valor instanceof Date)) {
      return [this.escapeDateForAllBrowsers(campo.valor)];
    }

    return campo.valor ? [campo.valor] : undefined;
  }
  private escapeDateForAllBrowsers(valor: any) {
    return valor.trim().replace(/[^\x00-\xFF]/g, '');
  }
  private getMultivaluesAdvancedSearch(valor: any): any {
    if (valor instanceof Array) {
      return valor.map(val => val instanceof SelectValue ? val.valor : val);
    }
    return valor;
  }

  setSerie(serie: any) {
    this.filtro.ID_SERIE = parseInt(serie, 10);
    this.expedientesProcesados.emit([]);
  }

  setClientSelected(event) {
    this.filtro.ID_CLIENTE = parseInt(event.cliente, 10);
  }

  private isInventoryUrlWithoutText(): boolean {
    return this.router.url.indexOf('inventarios/') == -1;
  }

  private searchRecordsByFilter() {
    this.setValuesToHighlightKeyword();
    this.reloadRecords();
  }

  private setValuesToHighlightKeyword(): any {
    if (this.filtro && this.filtro.VALORES) {
      const keywords = [];
      for (const prop of Object.keys(this.filtro.VALORES)) {
        const values: any[] = this.filtro.VALORES[prop];
        if (values && values.length > 0) {
          values.map(value => {
            if (value) {
              if (value instanceof SelectValue) {
                keywords.push(value.valor);
              } else {
                keywords.push(value);
              }
            }
          });
        }
      }

      if (keywords.length > 0) {
        this.keyword = new ElasticExpedientesByKeyword(keywords, this.inventoryService.getSearchOperator(), false, '');
      }
    }
  }

  public reloadRecords() {
    if (this.filtro || this.keyword) {
      let inicio = this.page.size * this.page.pageNumber;

      if (inicio != 0 && inicio >= this.page.totalElements) {
        inicio = inicio - this.page.size;
      }

      const fin = inicio + (+this.page.size);

      this.getPaginationRecords(inicio, fin);
    }
  }

  private getPaginationRecords(inicio: number, fin: number) {
    this.loading.emit(true);
    const method = this.isSearchByKeyword ? this.inventoryService.searchKeyword(inicio, fin, this.keyword, this.onlyPrestados, this.idGrupo ) // 🥑🥑 SRR agrego el idGRupo
      : this.inventoryService.searchInventarioExpedientes(inicio, fin, this.filtro, this.onlyPrestados);

    method.subscribe((value: IResultadoSearch<Expedientes>) => {
      this.proccessExpedientes(value);
    },
      error => {
        this.resultsShowed = new IResultadoSearch<Expedientes>();
        this.resultsShowed.total = 0;
        this.resultsShowed.isValid = false;
        this.resultsShowed.documents = [];

        this.setExpedients();
      });
  }

  private proccessExpedientes(value: IResultadoSearch<Expedientes>) {
    this.resultsShowed = this.filterRecordsExisted(value);
    this.page.totalElements = value.total;

    if (this.keyword) {
      this.insertFullTexts();
    }

    if (this.hasImagenesAsociadas(value)) {
      this.getMiniaturasImagenesAsociadas();
    }

    this.resultsShowed.documents = this.shoppingElementsService.getRecordsWithCartInformation(this.resultsShowed.documents);

    this.proccessFieldsToShow();
  }

  private proccessFieldsToShow() {
    const seriesId = this.getSeriesId(this.resultsShowed.documents);
    this.seriesService.getFieldsSerieOrdered(seriesId)
      .then((result: TemplateFieldsOrdered[][]) => {
        this.resultsShowed.documents.map(expediente => {
          if (!result) {
            this.setDefaultFieldsOrder();
            return;
          }
          let fieldsInSerie = result.find(res => !!res && res.some(x => x.campo.idSerie == expediente.document.serieId));

          if (!fieldsInSerie) {
            fieldsInSerie = [];
           }

          expediente.document.fieldsToShow = this.getFirstFieldValuesInRecord(expediente.document.valores, fieldsInSerie, this.numberFieldsShown);

          if (!expediente.document.fieldsToShow || expediente.document.fieldsToShow.length == 0) {
            expediente.document.fieldsToShow = this.getFieldsToShowFromValues(expediente.document.valores, this.numberFieldsShown);
          }
        });

        this.setExpedients();

      },
        error => {
          this.setDefaultFieldsOrder();
        });
  }

  private setDefaultFieldsOrder() {
    this.resultsShowed.documents.map(expediente => {
      const valuesSelected = expediente.document.valores._keys.slice(0, 6);
      const values = new Valores(valuesSelected.map(valueSelected => expediente.document.valores[valueSelected]));
      expediente.document.fieldsToShow = this.getFieldsToShowFromValues(values, this.numberFieldsShown);
    });
  }

  private getFieldsToShowFromValues(valores: Valores, numberFieldsShown: number): { key: string; value: any; }[] {
    const values: { key: string; value: any; }[] = [];
    // let contador = 0;
    valores.keys().forEach(key => {
      // if (contador < numberFieldsShown) {
        /*if (contador % 3 == 0) {
          values[row] = [];
        }*/
        values.push({ key: key, value: valores[key] });
        /*contador++;
        if (contador % 3 == 0) {
          row++;
        }*/
      // }
    });

    return values;
  }
  private getFirstFieldValuesInRecord(valores: Valores, fieldsInSerie: TemplateFieldsOrdered[], numberFieldsShown: number): { key: string; value: any; }[] {
    fieldsInSerie.sort((a, b) => a.order > b.order ? 1 : -1);
    let contador = 0;
    let valoresAux = new Valores([]);
    // Si los campos etiquetados con * son nulos, se cogen los seis primeros de los demás no nulos
    if (valores.keys().filter(key => key.startsWith('*') && valores[key]).length === 0) {
      valores.keys().filter(key => !key.startsWith('*') && valores[key]).sort().slice(0, 6).forEach(key => valoresAux[key] = valores[key]);
    } else {
      valoresAux = valores;
    }

    let valoresFinales;
    if (valoresAux.keys().some(key => key.startsWith('*'))) {
      valoresFinales = new Valores([]);
      valoresAux.keys().forEach(key => valoresFinales[key.startsWith('*') ? key.substring(1) : key] = valoresAux[key]);
    } else {
      valoresFinales = valoresAux;
    }


    const values: { key: string; value: any; }[] = [];
    fieldsInSerie.forEach(fieldInSerie => {
      if (fieldInSerie.campo.subtipo && fieldInSerie.campo.rango > 0) {
        if (fieldInSerie.campo.rango === 1 && !fieldInSerie.campo.descripcion.endsWith(' (desde)')) {
          fieldInSerie.campo.descripcion += ' (desde)';
        }
        if (fieldInSerie.campo.rango === 2 && !fieldInSerie.campo.descripcion.endsWith(' (hasta)')) {
          fieldInSerie.campo.descripcion += ' (hasta)';
        }
      }
      if (contador < numberFieldsShown && (valoresFinales.containsKey(fieldInSerie.campo.descripcion) ||
        valoresFinales.containsKey(fieldInSerie.campo.nombre) ||
        valoresFinales.containsKey('*' + fieldInSerie.campo.descripcion) || valoresAux.containsKey('*' + fieldInSerie.campo.nombre))) {

        const key = valoresFinales.containsKey(fieldInSerie.campo.descripcion) ? fieldInSerie.campo.descripcion : fieldInSerie.campo.nombre;
        if (fieldInSerie.campo.tipo === 'DATE') {
          const date = new Date(valoresFinales[fieldInSerie.campo.descripcion]);
          values.push({ key: key, value: `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` });
        } else {
          values.push({ key: key, value: valoresFinales[fieldInSerie.campo.descripcion] });
        }

        contador++;
      }
    });

    return values;
  }
  private getSeriesId(expedientes: IResultadoDocument<Expedientes>[]) {
    const unique = {};
    const distinct = [];
    for (let i = 0; expedientes.length > i; i++) {
      if (typeof (unique[expedientes[i].document.serieId]) == 'undefined') {
        distinct.push(expedientes[i].document.serieId);
      }
      unique[expedientes[i].document.serieId] = 0;
    }

    return distinct;
  }

  filterRecordsExisted(value: IResultadoSearch<Expedientes>): IResultadoSearch<Expedientes> {
    if (!this.expedientes) {
      return value;
    }
    const expedientes: IResultadoDocument<Expedientes>[] = [];
    value.documents.forEach((expediente: IResultadoDocument<Expedientes>) => {
      const exp: IResultadoDocument<Expedientes> = this.expedientes.find(document => document.id == expediente.id);
      if (exp && this.keyword && this.keyword.PALABRAS_CLAVE.some(x => exp.document.fullTextSummary
        && x == exp.document.fullTextSummary.textHighlightSearch)) {
        exp.document.hasFullTextCoincidence = expediente.document.hasFullTextCoincidence;
        expediente = exp;
      }
      expedientes.push(expediente);
    });
    value.documents = expedientes;
    return value;
  }

  private insertFullTexts() {
    // const recordsWithoutFullText = this.resultsShowed.documents.filter(document => !document.document.fullTextSummary);
    this.resultsShowed.documents.map(document => {
      this.putFullTextSummary(document);
    });
  }

  private putFullTextSummary(expediente: IResultadoDocument<Expedientes>) {
    const keywordsLower = this.getKeywordsLower(this.keyword);

    if (expediente.document.hasFullTextCoincidence) {
      this.putFullTextSummaryWithFullText(keywordsLower, expediente);
      return;
    }

    this.putFullTextSummaryWithValues(keywordsLower, expediente);

    if (!expediente.document.fullTextSummary && this.inventoryService.getCamposRango()) {
      expediente.document.fullTextSummary = new FullTextSummary();
      expediente.document.fullTextSummary.textBefore = this.translateService.instant('inventory.searchedByRange');
    }

  }
  private getKeywordsLower(keyword: ElasticExpedientesByKeyword): string[] {
    let keywordsLower: string[];
    if (this.keyword.OPERADOR == SearchOperators.AND) {
      keywordsLower = [this.keyword.PALABRAS_CLAVE.join(' ')];
    } else {
      keywordsLower = this.keyword.PALABRAS_CLAVE.filter(palabraClave => !this.isDate(palabraClave))
        .map(palabraClave => palabraClave.toLowerCase());
    }

    return keywordsLower;

  }
  private isDate(palabraClave: any): boolean {
    return palabraClave instanceof Date;
  }

  private putFullTextSummaryWithValues(keywordsLower: string[], expediente: IResultadoDocument<Expedientes>) {
    const values = expediente.document.valores;

    expediente.document.fullTextSummary = this.getEntireCoincidenceInField(values, keywordsLower);

    const keys = values.keys();

    for (let valueCount = 0; valueCount < keys.length && !expediente.document.fullTextSummary; valueCount++) {
      const value = values[keys[valueCount]];
      if (this.isMultivalue(value)) {
        for (let multivalueCount = 0; multivalueCount < value.length && !expediente.document.fullTextSummary; multivalueCount++) {
          expediente.document.fullTextSummary = this.getFullTextSummaryFromText(keys[valueCount], value[multivalueCount], keywordsLower);
        }
      } else {
        expediente.document.fullTextSummary = this.getFullTextSummaryFromText(keys[valueCount], value, keywordsLower);
      }
    }

  }
  private getEntireCoincidenceInField(values: Valores, keywordsLower: string[]): FullTextSummary {
    const keywordComplete: string = keywordsLower.join(' ');

    const keys = values.keys();
    const fullTextsSummary: FullTextSummary[] = keys.map(key => {
      const val = values[key];
      let fulltext: FullTextSummary;
      if (this.isMultivalue(val)) {
        const multivalues = (<any[]>val);
        for (let multivalueCount = 0; multivalueCount < multivalues.length && !fulltext; multivalueCount++) {
          fulltext = this.getFullTextSummaryFromText(key, multivalues[multivalueCount], [keywordComplete]);
        }
      } else {
        fulltext = this.getFullTextSummaryFromText(key, val, [keywordComplete]);
       }

      return fulltext;
    });

    return fullTextsSummary.find(fts => !!fts);
  }
  private getFullTextSummaryFromText(title: string, valueText: any, keywords: string[]): FullTextSummary {
    valueText = typeof valueText === 'number' ? valueText.toString() : valueText;
    if (typeof valueText === 'string' && !this.matchDate(valueText)) {
      const fullTextSummary: FullTextSummary = this.highlightService.getFirstOccurrenceHighligth(valueText, keywords);

      if (fullTextSummary) {
        fullTextSummary.textBefore = this.trimFirstAsteriscCharacter(title) + ': ' + fullTextSummary.textBefore;
        return fullTextSummary;
      }
    }
  }
  private matchDate(valueText: string) {
    const regex = new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])T\d{2}:\d{2}:\d{2}Z$/, 'g');
    const match = regex.exec(valueText);

    return match && match.index != 1;

  }
  private trimFirstAsteriscCharacter(string: string) {
    return string.replace(/^\*/g, '');
  }
  private isMultivalue(value: any): any {
    return value instanceof Array;
  }

  private putFullTextSummaryWithFullText(keywordsLower: string[], expediente: IResultadoDocument<Expedientes>) {
    expediente.document.fullTextSummary = this.getFullTextSummaryFromHojasFullText(expediente.document.imagenAsociada.hojasFullText, keywordsLower);

    if (!expediente.document.fullTextSummary && expediente.document.parciales) {
      let fullTextSummary: FullTextSummary = null;

      for (let numPartial = 0; numPartial <= expediente.document.parciales.length && !fullTextSummary; numPartial++) {
        fullTextSummary = this.getFullTextSummaryFromHojasFullText(expediente.document.parciales[numPartial].imagenAsociada.hojasFullText, keywordsLower);
        if (fullTextSummary) {
          fullTextSummary.textBefore = 'PARTIAL ' + expediente.document.parciales[numPartial].parcialId + ': ' + fullTextSummary.textBefore;
        }
      }

      expediente.document.fullTextSummary = fullTextSummary;
    }
  }
  private getFullTextSummaryFromHojasFullText(hojasFullText: FullTextHojas[], keywordsLower: string[]): FullTextSummary {
    const texts = hojasFullText.map(hojaFullText => hojaFullText.fullText);

    return this.highlightService.getFirstOccurrenceInListTextHighligth(texts, keywordsLower, this.keyword.OPERADOR);
  }

  private hasImagenesAsociadas(value: IResultadoSearch<Expedientes>): boolean {
    return value.documents.some(document => document.document.imagenAsociada != null);
  }

  private getMiniaturasImagenesAsociadas() {

    const documentExpedientesWithImagenAsociada = this.resultsShowed.documents
      .filter(document => document.document.imagenAsociada && !document.document.imagenAsociada.imageMiniaturaSrc)
      .map(document => document);

    documentExpedientesWithImagenAsociada.map(documentExpediente => {

      this.imagenCacheService.getImageArrayBufferByGuid(documentExpediente.document.imagenAsociada.GUID_miniaturas)
        .then((data: ArrayBuffer) => {
          documentExpediente.document.imagenAsociada.imageMiniaturaSrc = data;
        });
    });
  }

  private setExpedients() {
    this.expedientes = [...this.resultsShowed.documents.map(document => document)];
    this.loading.emit(false);
    this.rechargeRecordsChange.emit(false);
    this.expedientesProcesados.emit(this.expedientes);
  }

  setFielsRangeInSearch(hasFieldsRange) {
    this.hasFieldsRange = hasFieldsRange;
    this.inventoryService.setCamposRango(hasFieldsRange);
  }

}
